var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2978 0.263343C15.7505 0.0935543 16.2495 0.0935544 16.7022 0.263343L18.4425 0.915955C22.1213 2.29547 25.5414 4.28453 28.5597 6.79973L29.3937 7.49475C29.7833 7.8194 30.035 8.27992 30.0979 8.78313L30.4573 11.6588C30.8177 14.5417 30.8177 17.4583 30.4573 20.3412L30.0979 23.2169C30.035 23.7201 29.7833 24.1806 29.3937 24.5052L28.5597 25.2003C25.5414 27.7155 22.1213 29.7045 18.4425 31.084L16.7022 31.7367C16.2495 31.9064 15.7505 31.9064 15.2978 31.7367L13.5575 31.084C9.87874 29.7045 6.45856 27.7155 3.44033 25.2003L2.6063 24.5052C2.21672 24.1806 1.96501 23.7201 1.90211 23.2169L1.54265 20.3412C1.18229 17.4583 1.18229 14.5417 1.54265 11.6588L1.90211 8.78313C1.96501 8.27992 2.21672 7.8194 2.6063 7.49475L3.44033 6.79973C6.45857 4.28453 9.87874 2.29547 13.5575 0.915954L15.2978 0.263343Z",
    fill: "#51B98D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.2978 0.263343C15.7505 0.0935543 16.2495 0.0935544 16.7022 0.263343L18.4425 0.915955C22.1213 2.29547 25.5414 4.28453 28.5597 6.79973L29.3937 7.49475C29.7833 7.8194 30.035 8.27992 30.0979 8.78313L30.4573 11.6588C30.8177 14.5417 30.8177 17.4583 30.4573 20.3412L30.0979 23.2169C30.035 23.7201 29.7833 24.1806 29.3937 24.5052L28.5597 25.2003C25.5414 27.7155 22.1213 29.7045 18.4425 31.084L16.7022 31.7367C16.2495 31.9064 15.7505 31.9064 15.2978 31.7367L13.5575 31.084C9.87874 29.7045 6.45856 27.7155 3.44033 25.2003L2.6063 24.5052C2.21672 24.1806 1.96501 23.7201 1.90211 23.2169L1.54265 20.3412C1.18229 17.4583 1.18229 14.5417 1.54265 11.6588L1.90211 8.78313C1.96501 8.27992 2.21672 7.8194 2.6063 7.49475L3.44033 6.79973C6.45857 4.28453 9.87874 2.29547 13.5575 0.915954L15.2978 0.263343Z",
    fill: "url(#paint0_linear)",
    fillOpacity: 0.12,
    style: {
      mixBlendMode: "overlay"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 11,
    y1: 32,
    x2: 11,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222222"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.29392f6ff74bfdd22fce8b4b9b057988.svg";
export { ForwardRef as ReactComponent };